import ClickOutside from 'vue-click-outside';
import { WidgetInitializer } from "../functions/widget-initializer";
import { LocalStorageUtils } from "../functions/local-storage-utils";
import { ArrayUtils } from "../functions/array-utils";
import { ConfigUtils } from "../functions/config-utils";
import { StringUtils } from "../functions/string-utils";
import { Constants } from "../functions/constants";
import { BranchUtils } from "../functions/branch-utils";

var widgetInitializer = new WidgetInitializer(Constants.COMPONENTS.BRANCH_PICKER);
GlobalApp.registerInitializationHandler(Constants.COMPONENTS.BRANCH_PICKER, function () {
    widgetInitializer.initialize(initHeaderBranchInfoApp);
});

function initHeaderBranchInfoApp(element) {
    var config = ConfigUtils.getConfigFor(element);

    var vueApp = new Vue({
        el: '#' + element.id,
        data: {
            initializationReadyHook: GlobalApp.getInitializationReadyHook(),
            buttonTitle: 'PICK A STORE',
            storeTitle: '',
            storeData: '',
            phoneNumbers: null,
            storeLink: '',
            searchTerm: '',
            currentAddressLink: '',
            popupShown: false,
            myStoreLocationData: {},
            inputTextSelected: false
        },
        directives: {
            ClickOutside
        },
        computed: {
            inputHeaderText() {
                return this.storeData ? 'Change Store' : 'Pick a Store';
            },
            visiblePhoneNumbers() {
                var that = this;
                if (ArrayUtils.isNotEmpty(this.phoneNumbers)) {
                    return this.phoneNumbers
                        .filter(pn => pn.isVisible)
                        .map(pn => {
                            pn.displayName = that.getPhoneDisplayName(pn);
                            return pn;
                        });
                }
                return [];
            },
            isOnscreenKeyboardShown () {
                return GlobalApp.isOnscreenKeyboardShown && this.popupShown;
            }
        },
        methods: {
            init: function init() {
                var that = this;
                var stored_data = LocalStorageUtils.getLocalStorageData();
                this.searchTerm = stored_data.searchTerm;

                GlobalApp.MyStoreService.getMyStore()
                    .then(function (myStoreData) {
                        if (myStoreData)
                            that.displayBranchDetails(myStoreData);

                        that.initializationReadyHook(element.id);
                    });
            },
            setPopupInfo: function setPopupInfo(obj) {
                this.storeTitle = obj.title;
                this.storeData = obj.data;
                this.phoneNumbers = StringUtils.jsonTryParse(obj.phoneNumbers);
                this.buttonTitle = obj.buttonTitle;
                this.storeLink = obj.link;
            },
            goToLocations: function goToLocations() {
                if (this.searchTerm) {
                    LocalStorageUtils.updateLocalStorageData(otherPreferences => {
                        otherPreferences.searchTerm = this.searchTerm;
                    });

                    window.location.href = config.model.BranchFinderLink.LinkUrl;
                }
            },
            togglePopupExpanded: function () {
                if (!this.popupShown) {
                    this.init();
                    GlobalApp.EventHub.raiseEvent(Constants.EVENTS.CLOSE_ALL_POPUPS);
                    GlobalApp.EventHub.raiseEvent(Constants.EVENTS.POPUP_OPENED);
                } else {
                    GlobalApp.EventHub.raiseEvent(Constants.EVENTS.POPUP_CLOSED);
                }

                this.popupShown = !this.popupShown;
            },
            mouseDown: function mouseDown() {
                this.inputTextSelected = true
            },
            mouseUp: function mouseUp() {
                this.inputTextSelected = false
            },
            hidePopup: function hidePopup() {
                if (this.popupShown && !this.inputTextSelected) {
                    this.popupShown = false; 
                    GlobalApp.EventHub.raiseEvent(Constants.EVENTS.POPUP_CLOSED);
                }
                this.inputTextSelected = false
            },
            getCurrentPosition: function getCurrentPosition() {
                GlobalApp.LocationService.getDeviceLocation()
                    .then(this.saveCurrentCoords)
                    .catch(function (error) {
                        console.warn(error);
                    });
            },
            saveCurrentCoords: function saveCurrentCoords(position) {
                LocalStorageUtils.updateLocalStorageData(otherPreferences => {
                    otherPreferences.searchTerm = "";
                });

                this.currentAddressLink += '?lat=' + position.Latitude + '&lng=' + position.Longitude;
                window.location.href = this.currentAddressLink;
            },
            getAddressText: function getAddressText(obj) {
                if (!obj) { return ''; }
                return obj.Street + ', ' + obj.City + ' ' + obj.Zip;
            },
            hidePopupWithDelay: function hidePopupWithDelay() {
                var that = this;
                setTimeout(function () {
                    that.togglePopupExpanded();
                }, 100);
            },
            myStoreUpdateEventHandler: function (object, branchDetails) {
                if (object === this)
                    return;

                this.displayBranchDetails(branchDetails);
            },
            displayBranchDetails: function (branchDetails) {
                if (!branchDetails)
                    return;

                var contactData = branchDetails.FormattedAddress || BranchUtils.getAddressString(branchDetails);

                this.setPopupInfo({
                    title: branchDetails.BranchName,
                    data: contactData,
                    phoneNumbers: branchDetails.PhoneNumbers,
                    buttonTitle: 'MY STORE',
                    link: branchDetails.Url
                });
            },
            getPhoneDisplayName: function (item) {
                if (!item || !item.value)
                    return '';

                var displayName = item.value.replace(
                    new RegExp(config.phoneConstants.parsingRegex),
                    config.phoneConstants.formattingRegex
                );
                return displayName;
            }
        },
        created: function () {
            this.init();
            this.currentAddressLink = config.model.BranchFinderLink.LinkUrl;
            GlobalApp.EventHub.subscribeToEvent(Constants.EVENTS.CLOSE_ALL_POPUPS, this.hidePopup);
            GlobalApp.EventHub.subscribeToEvent(Constants.EVENTS.CART.MY_STORE_UPDATE, this.myStoreUpdateEventHandler);
            window.addEventListener(Constants.EVENTS.CART.LOCATION_POPUP_OPENED, this.hidePopupWithDelay);
        },
        destroyed() {
            GlobalApp.EventHub.unsubscribeToEvent(Constants.EVENTS.CLOSE_ALL_POPUPS, this.hidePopup);
            GlobalApp.EventHub.unsubscribeToEvent(Constants.EVENTS.CART.MY_STORE_UPDATE, this.myStoreUpdateEventHandler);
            window.removeEventListener(Constants.EVENTS.CART.LOCATION_POPUP_OPENED, this.hidePopupWithDelay);
        }
    });

    return vueApp.$el;
}